import { fetchAPI, fetchAPIBlob } from "../config/api";
import { toDivisionApi } from "../config/constants";

export const fetchPlayer = (playerId, signal) =>
  fetchAPI(`/api/player/${encodeURIComponent(playerId)}`, { signal });

export const fetchPlayerYears = (playerId, division, signal) =>
  fetchAPI(`/api/player-years/${encodeURIComponent(playerId)}/${division}`, { signal });

export const fetchPlayerStats = (playerId, statType, division, signal) =>
  fetchAPI(
    `/api/leaderboards/${statType}/${encodeURIComponent(playerId)}?start_year=2021&end_year=2025&division=${division}`,
    { signal }
  );

export const fetchPlayerPercentiles = (playerId, year, division, conference) => {
  let url = `/api/player-percentiles/${encodeURIComponent(playerId)}/${year}/${division}`;
  if (conference && conference !== "all") {
    url += `?conference=${encodeURIComponent(conference)}`;
  }
  return fetchAPI(url);
};

export const fetchSimilarBatters = (playerId, year, division, signal) =>
  fetchAPI(
    `/api/similar-batters/${encodeURIComponent(playerId)}?year=${year}&division=${division}`,
    { signal }
  );

export const fetchSimilarPitchers = (playerId, year, division, signal) =>
  fetchAPI(
    `/api/similar-pitchers/${encodeURIComponent(playerId)}?year=${year}&division=${division}`,
    { signal }
  );

export const fetchPlayerGameLog = (playerId, division, signal) => {
  const divApi = toDivisionApi(division);
  const params = new URLSearchParams();
  if (divApi) params.set("division", divApi);
  return fetchAPI(`/player/${encodeURIComponent(playerId)}/game-log?${params}`, { signal });
};

export const fetchPlayerPositions = (playerId, year, division, signal) => {
  const params = new URLSearchParams({ year: String(year), role: "batting" });
  if (division) params.append("division", String(division));
  return fetchAPI(`/api/player/${encodeURIComponent(playerId)}/positions?${params}`, { signal });
};

export const fetchRollingData = (playerId, window, playerType, stat, signal) =>
  fetchAPI(
    `/api/rolling/${encodeURIComponent(playerId)}?window=${window}&player_type=${playerType}&stat=${stat}`,
    { signal }
  );

export const fetchSprayChartData = (playerId, year, division, signal) =>
  fetchAPI(
    `/spraychart_data/${playerId}?year=${year}&division=${toDivisionApi(division)}`,
    { signal }
  );

export const exportSprayChart = (params) =>
  fetchAPIBlob(`/api/reports/spray_chart?${params.toString()}`);
